import { useTranslation } from 'react-i18next';
import styles from './CopyNeedsAssessment.module.scss';
import { useState } from 'react';
import { Modal, Button, TextField } from '@mui/material';
import { copy } from 'api/needsassessments';

export default function CopyNeedsAssessment(props) {
  const { t } = useTranslation();
  const { assessment, open, onClose } = props;

  const [assessmentName, setAssessmentName] = useState(assessment.name);
  const [companyName, setCompanyName] = useState(assessment.companyName);
  const [loading, setLoading] = useState(false);

  const cancel = () => {
    onClose(null);
  };

  const confirm = async () => {
    setLoading(true);

    const naCopy = {
      originalAssessmentId: assessment.id,
      assessmentName,
      companyName,
    };
    const copiedNa = await copy(naCopy);
    onClose(copiedNa);
    setLoading(false);
  };

  return (
    <Modal open={open} onClose={() => onClose(null)}>
      <div data-testid="CopyNeedsAssessmentDialog" className={styles.copy_container}>
        <h3>{t('copyDialog.title')}</h3>
        <div className={styles.copy__label_container}>
          <span className={styles.copy__label}>{t('copyDialog.projectName')}</span>
        </div>
        <TextField
          data-testid="CopyNeedsAssessmentAssessmentNameText"
          className={styles.copy__input}
          value={assessmentName}
          onChange={(event) => setAssessmentName(event.target.value)}
        />
        <div className={styles.copy__label_container}>
          <span className={styles.copy__label}>{t('copyDialog.companyName')}</span>
        </div>

        <TextField
          data-testid="CopyNeedsAssessmentCompanyNameText"
          className={`${styles.copy__input}`}
          value={companyName}
          onChange={(event) => setCompanyName(event.target.value)}
        />
        <div className={styles.buttons_container}>
          <Button
            data-testid="CopyNeedsAssessmentCancelBtn"
            className={`${styles.button} ${styles.secondary}`}
            size="small"
            color="secondary"
            variant="contained"
            onClick={() => cancel()}>
            {t('common.cancel')}
          </Button>
          <Button
            disabled={loading}
            data-testid="CopyNeedsAssessmentSaveBtn"
            className={`${styles.button} ${styles.primary}`}
            size="small"
            color="primary"
            variant="contained"
            onClick={() => confirm()}>
            {t('copyDialog.createButton')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
